import { lightColorPalette } from '@linearb/linui-common';
import { ISSUE_STATUSES, LINB_ISSUE_STATES } from '../../state/issue.statuses';

export const mapColKeyToStyle = {
  [LINB_ISSUE_STATES.CREATED]: {
    color: ISSUE_STATUSES?.[LINB_ISSUE_STATES.CREATED].color,
    borderColor: ISSUE_STATUSES?.[LINB_ISSUE_STATES.CREATED].color
  },
  [LINB_ISSUE_STATES.WIP]: {
    color: ISSUE_STATUSES?.[LINB_ISSUE_STATES.WIP].color,
    borderColor: ISSUE_STATUSES?.[LINB_ISSUE_STATES.WIP].color
  },
  [LINB_ISSUE_STATES.DONE]: {
    color: ISSUE_STATUSES?.[LINB_ISSUE_STATES.DONE].color,
    borderColor: ISSUE_STATUSES?.[LINB_ISSUE_STATES.DONE].color
  },
  [LINB_ISSUE_STATES.ACC_DONE]: {
    color: lightColorPalette.lbWhite,
    borderColor: lightColorPalette.lbGreenDark
  }
};
